import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {transactionPerformancePaymentCategory_template} from "./transactionPerformancePaymentCategory_template";
import {transactionPremiumPaymentCategory_template} from "./transactionPremiumPaymentCategory_template";
import {PaymentCategorySystem} from "../../utils/types/payment_categories";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;


export class transactionPaymentCategory_template extends vnTemplate {

    public premiumPaymentCategorySystemTemplate: transactionPremiumPaymentCategory_template;
    public performancePaymentCategorySystemTemplate: transactionPerformancePaymentCategory_template;
    public resourcePaymentCategorySystemTemplate: transactionPerformancePaymentCategory_template;
    public validationsList: validationsList_template;

    protected getTemplateName(): string {
        return "transactionPaymentCategory_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div id="transaction-payment-systems-list-results" class=" list-results w-form w-transaction-payment-systems">
                ${this.validationsList.getHtmlBuild()}
                <div class="form-header" >
                    <h3 class="form-title icon i-target">Transaction Payment Categories</h3>
                </div>
                <div class="form-pagination">
                    <button class="btn icon i-article" type="button" data-bind="event: { click: onClickTab.bind($data, 'news and access') }, css: { 'is-activated' : system() == 'news and access'}">
                        <span class="btn-text">News and Access Categories</span>
                    </button>
                    <button class="btn icon i-performance" type="button" data-bind="event: { click: onClickTab.bind($data, 'performance') }, css: { 'is-activated' : system() == 'performance'}">
                        <span class="btn-text">Performance Categories</span>
                    </button>
                    <button class="btn icon i-profiles" type="button" data-bind="event: { click: onClickTab.bind($data, 'resource') }, css: { 'is-activated' : system() == 'resource'}">
                        <span class="btn-text">Resource Categories</span>
                    </button>
                </div>
                <div class="" data-bind="visible: (system() == 'news and access')">
                    ${this.premiumPaymentCategorySystemTemplate.getHtmlBuild()}
                </div>
                <div class="" data-bind="visible: system() == 'performance'">
                    ${this.performancePaymentCategorySystemTemplate.getHtmlBuild()}
                </div>
                <div class="" data-bind="visible: system() == 'resource'">
                    ${this.resourcePaymentCategorySystemTemplate.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-form-body"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            filterBySystem: ko.observable(false),
            system: ko.observable(PaymentCategorySystem.NEWSANDACCESS),
            paymentCategories: ko.observableArray([]),
            onClickTab: (value, data, event): void => {
                self.onClickTab(value);
            }
        };
    }

    protected initPartial() {
        this.premiumPaymentCategorySystemTemplate = new transactionPremiumPaymentCategory_template('premiumPaymentCategoryTabTemplate', this.getTemplateViewModel(), this.caller);
        this.premiumPaymentCategorySystemTemplate.setParent(this);
        this.premiumPaymentCategorySystemTemplate.setSystem(PaymentCategorySystem.NEWSANDACCESS);

        // tslint:disable-next-line:max-line-length
        this.performancePaymentCategorySystemTemplate = new transactionPerformancePaymentCategory_template('performancePaymentCategoryTabTemplate', this.getTemplateViewModel(), this.caller);
        this.performancePaymentCategorySystemTemplate.setParent(this);
        this.performancePaymentCategorySystemTemplate.setSystem(PaymentCategorySystem.PERFORMANCE);

        this.resourcePaymentCategorySystemTemplate = new transactionPerformancePaymentCategory_template('resourcePaymentCategoryTabTemplate', this.getTemplateViewModel(), this.caller);
        //this.resourcePaymentCategorySystemTemplate = new transactionPremiumPaymentCategory_template('resourcePaymentCategoryTabTemplate', this.getTemplateViewModel(), this.caller);
        this.resourcePaymentCategorySystemTemplate.setParent(this);
        this.resourcePaymentCategorySystemTemplate.setSystem(PaymentCategorySystem.RESOURCE);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    protected onClickTab(tab): void {
        this.setSystem(tab);
        this.setFilterBySystem(true);
    }

    public setTransactionPaymentCategoriesFromServer(systems: { [key: string]: any }): void {

        if (systems['news and access']) {
            this.premiumPaymentCategorySystemTemplate.setTransactionPaymentCategoriesFromServer(systems['news and access']);
        }
        if (systems['performance']) {
            this.performancePaymentCategorySystemTemplate.setTransactionPaymentCategoriesFromServer(systems['performance']);
        }
        if (systems['resource']) {
            this.resourcePaymentCategorySystemTemplate.setTransactionPaymentCategoriesFromServer(systems['resource']);
        }
    }

    public getSystem(): string {
        return this.getTemplateViewModel().system();
    }

    public setSystem(system): string {
        return this.getTemplateViewModel().system(system);
    }

    public isPerformanceSystem(): boolean {
        const system = this.getSystem();
        return (system === PaymentCategorySystem.PERFORMANCE);
    }

    private getActiveSystemTemplate(): any {
        const system = this.getSystem();
        if (system === PaymentCategorySystem.PERFORMANCE) {
            return this.performancePaymentCategorySystemTemplate;
        }
        if (system === PaymentCategorySystem.RESOURCE) {
            return this.resourcePaymentCategorySystemTemplate;
        }
        return this.premiumPaymentCategorySystemTemplate;
    }

    /**
     * Returns a list of session brands to be saved in the system
     */
    public getViewModelForRequest() {

        return this.getActiveSystemTemplate().getViewModelForRequest();
    }


    public getTransactionPaymentCategories() {
        return this.getActiveSystemTemplate().getTransactionPaymentCategories();
    }

    public getPostRequestData() {
        return this.getActiveSystemTemplate().getPostRequestData();
    }

    public getGetRequestData() {
        return this.getActiveSystemTemplate().getGetRequestData();
    }

    public setFilterBySystem(filterBySystem): void {
        this.getTemplateViewModel().filterBySystem(filterBySystem);
    }

    public isFilterBySystem(): boolean {
        return this.getTemplateViewModel().filterBySystem();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/transactionPaymentCategory_template.ts